var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoAnalyze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.01758,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#700AC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.01758,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#7951EB",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.018 38.5C22.4945 38.5 18.0176 34.0233 18.0176 28.5C18.0176 22.9767 22.4945 18.5 28.018 18.5C33.5407 18.5 38.0176 22.9767 38.0176 28.5C38.0176 34.0233 33.5407 38.5 28.018 38.5Z",
    fill: "#700AC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0186 24.5C28.5708 24.5 29.0186 24.0523 29.0186 23.5C29.0186 22.9477 28.5708 22.5 28.0186 22.5C27.4663 22.5 27.0186 22.9477 27.0186 23.5C27.0186 24.0523 27.4663 24.5 28.0186 24.5ZM28.0186 34.5C28.5708 34.5 29.0186 34.0523 29.0186 33.5L29.0186 27.5C29.0186 26.9477 28.5708 26.5 28.0186 26.5C27.4663 26.5 27.0186 26.9477 27.0186 27.5V33.5C27.0186 34.0523 27.4663 34.5 28.0186 34.5Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAnalyze);
export default __webpack_public_path__ + "static/media/info_analyze.8fa36a486f5ef9a0eb80c806726e832b.svg";
export { ForwardRef as ReactComponent };